"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowGuestAddResponse = exports.ShowGuestAddRequest = void 0;
var show_guest_add_1 = require("./show-guest-add");
Object.defineProperty(exports, "ShowGuestAddRequest", { enumerable: true, get: function () { return show_guest_add_1.ShowGuestAddRequest; } });
Object.defineProperty(exports, "ShowGuestAddResponse", { enumerable: true, get: function () { return show_guest_add_1.ShowGuestAddResponse; } });
